/* La Fleury — ventana de bienvenida (10 %).
   Se abre una vez por visitante: a los 8 s, al bajar el 40 % de la página o al
   ir a cerrar la pestaña en escritorio. Si la cierran, descansa 7 días y deja
   una pastilla abajo para volver a abrirla. Quien ya se ha suscrito no la ve más. */
(function () {
  var d = document.getElementById('lf-pop');
  if (!d || typeof d.showModal !== 'function') return;

  var DAY = 864e5;
  var K = { sub: 'lf-pop-sub', snooze: 'lf-pop-snooze', pill: 'lf-pop-pill-off', sent: 'lf-pop-sent', code: 'lf-pop-code' };
  function get(s, k) { try { return s.getItem(k); } catch (e) { return null; } }
  function set(s, k, v) { try { s.setItem(k, v); } catch (e) {} }
  function del(s, k) { try { s.removeItem(k); } catch (e) {} }
  var L = window.localStorage, S = window.sessionStorage;

  var params = new URLSearchParams(location.search);
  var live = d.dataset.live === 'true' || params.get('lf_popup') === '1';
  var pill = document.getElementById('lf-pop-pill');
  var done = d.querySelector('[data-lf-pop-done]');
  var error = d.querySelector('[data-lf-pop-error]');
  var ours = get(S, K.sent) === '1' || location.hash === '#lf-pop-form';
  var opened = false;

  function open() {
    if (opened || d.open) return;
    opened = true;
    if (pill) pill.hidden = true;
    d.showModal();
  }
  function close() {
    if (d.open) d.close();
  }
  d.addEventListener('close', function () {
    if (done || get(L, K.sub)) return;
    set(L, K.snooze, String(Date.now() + 7 * DAY));
    if (pill && !get(L, K.pill)) pill.hidden = false;
  });

  // Vuelta del formulario: éxito o error, solo si lo envió esta ventana
  if (done && ours) {
    set(L, K.sub, '1');
    del(S, K.sent);
    open();
  } else if (error && ours) {
    del(S, K.sent);
    open();
    var input = d.querySelector('input[type="email"]');
    if (input) input.focus();
  } else if (live && !get(L, K.sub)) {
    var until = Number(get(L, K.snooze) || 0);
    if (until > Date.now()) {
      if (pill && !get(L, K.pill)) pill.hidden = false;
    } else {
      schedule();
    }
  }

  function schedule() {
    var t = setTimeout(go, 8000);
    function onScroll() {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0 && scrollY / h > 0.4) go();
    }
    function onLeave(e) { if (e.clientY <= 0 && !e.relatedTarget) go(); }
    function go() {
      clearTimeout(t);
      removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onLeave);
      // No taparle el carrito ni el menú si los tiene abiertos
      if (document.querySelector('cart-drawer.active, details[open] > .menu-drawer, .search-modal[open]')) {
        t = setTimeout(go, 6000);
        return;
      }
      open();
    }
    addEventListener('scroll', onScroll, { passive: true });
    if (matchMedia('(hover: hover)').matches) document.addEventListener('mouseout', onLeave);
  }

  // Cerrar: X, «No, thanks», clic fuera de la tarjeta (Esc lo hace <dialog> solo)
  d.addEventListener('click', function (e) {
    if (e.target === d || e.target.closest('[data-lf-pop-close]')) close();
  });

  var form = d.querySelector('form');
  if (form) form.addEventListener('submit', function (e) {
    var input = form.querySelector('input[type="email"]');
    e.preventDefault();
    if (!input || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim())) {
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
      return;
    }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = d.dataset.tWait || 'One moment…'; }
    set(S, K.sent, '1');
    // 1) Widy guarda el alta y crea su código único en Shopify; 2) el formulario nativo
    // la da de alta en Clientes con permiso de marketing. Si Widy tarda, se sigue igual.
    var enviado = false;
    function seguir() { if (enviado) return; enviado = true; HTMLFormElement.prototype.submit.call(form); }
    setTimeout(seguir, 8000);
    pedirCodigo(input.value.trim()).then(function (codigo) {
      if (codigo) set(S, K.code, codigo);
      seguir();
    }, seguir);
  });

  // Alta en la base de datos de Widy (panel.widy.agency → Suscriptores) y código único.
  function pedirCodigo(email) {
    var datos = JSON.stringify({
      tienda: 'lafleury', email: email, fuente: 'popup', etiquetas: ['newsletter', 'popup-10'],
      pagina: location.pathname, idioma: document.documentElement.lang || navigator.language
    });
    return fetch('https://panel.widy.agency/api/suscribir', {
      method: 'POST', body: datos, headers: { 'Content-Type': 'text/plain' }, keepalive: true
    }).then(function (r) { return r.json(); }).then(function (j) { return j && j.codigo; });
  }

  // Tras volver del formulario: pintar SU código (o el aviso si no llegó a crearse)
  var RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (done) {
    var mio = get(S, K.code) || d.dataset.code || '';
    var pon = function (sel, fn) { Array.prototype.forEach.call(d.querySelectorAll(sel), fn); };
    if (mio) {
      d.dataset.code = mio;
      pon('[data-lf-pop-code]', function (el) { el.textContent = mio; });
      pon('[data-lf-pop-shop]', function (el) { el.href = '/discount/' + encodeURIComponent(mio) + '?redirect=' + encodeURIComponent(RAIZ + 'collections/all'); });
    } else {
      pon('[data-lf-pop-con]', function (el) { el.hidden = true; });
      pon('[data-lf-pop-sin]', function (el) { el.hidden = false; });
      pon('[data-lf-pop-shop]', function (el) { el.href = RAIZ + 'collections/all'; });
    }
  }

  var copy = d.querySelector('[data-lf-pop-copy]');
  if (copy) copy.addEventListener('click', function () {
    var code = d.dataset.code;
    var ok = function () { copy.textContent = d.dataset.tCopied || 'Copied'; };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, function () {});
  });

  if (pill) {
    pill.querySelector('[data-lf-pop-open]').addEventListener('click', function () { opened = false; open(); });
    pill.querySelector('[data-lf-pop-pill-x]').addEventListener('click', function () {
      pill.hidden = true;
      set(L, K.pill, '1');
    });
  }
})();
